import React from 'react';
import { SelectDesignerLabels } from '@99designs/apps/spa/pages/create/components/AddDesignerButton';
import { Stat } from '@99designs/designers';

interface DesignerCardContext {
    stats?: Stat[];
    selectDesignerLabels: SelectDesignerLabels;
}

export default React.createContext<DesignerCardContext>({
    stats: [Stat.Responsiveness, Stat.ProjectCount, Stat.RepeatClients],
    selectDesignerLabels: {
        selected: __('Added'),
        notSelected: __('Add'),
    },
});
